import Link from 'next/link'

const ListCreditLink = ({ link, name }) => (
  <Link href={link}>
    <a className="blue no-underline underline-hover" href={link}>
      {name}
    </a>
  </Link>
)

const ListHeaderCredit = ({ link, name }) => (
  <div className="f4 lh-copy mv0 tracked-light">
    <span>by&nbsp;</span>
    {link ? <ListCreditLink link={link} name={name} /> : <span>{name}</span>}
  </div>
)

export default ListHeaderCredit
